import Model, { attr } from '@ember-data/model';

export default class NoteSignatureOverviewModel extends Model {
  @attr('json') allSignatures;
}
